import { useCallback, useMemo } from "react";
import { isEmpty } from "lodash";
import { useItems } from "atoms/itemAtom";
import { Item } from "types";

import { MediumText } from "components/MediumText/MediumText";
import { Checkbox } from "components/Checkbox/Checkbox";
import { Row } from "components/Row/Row";
import { Paragraph } from "components/Paragraph/Paragraph";

type Props = {
  productsList: Item[];
};

export function ProductsHeader({ productsList }: Props) {
  /*  const { itemsState, setItemsState } = useItems();

  const isAllchecked = useMemo(() => {
    return (
      !isEmpty(itemsState.checkedItems) &&
      itemsState.checkedItems.length === productsList.length
    );
  }, [itemsState, productsList]);

  const handleSelectUnselectAll = useCallback(() => {
    setItemsState({
      ...itemsState,
      checkedItems: isAllchecked ? [] : productsList,
    });
  }, [isAllchecked, productsList]);*/

  return (
    <Row>
      <div className="flex flex-1 gap-6 items-center">
        {/*<Checkbox onChange={handleSelectUnselectAll} checked={isAllchecked} />*/}
        <Paragraph width={100}>
          <MediumText>№</MediumText>
        </Paragraph>
        <Paragraph width={250}>
          <MediumText>Товар</MediumText>
        </Paragraph>
      </div>
      <MediumText>Стоимость, ₽</MediumText>
    </Row>
  );
}
